import React, { useEffect, useState, useRef } from 'react';
import { useContext } from 'react';
import { CreatableDropdown, Dropdown } from '../../../../components';
import InputField from '../../../../components/InputField';
import { userContext } from '../../../../contextProvider/Authentication';
import { getAPIIds } from '../../../../Functions/apis';
import axiosInstance from '../../../../services/AxiosInstance';
import SimpleReactValidator from 'simple-react-validator';
import swal from 'sweetalert';

function CareerInterest({
    stud_id
}) {

    const [input, setInput] = useState();
    const [, forceUpdate] = useState();
    const { user } = useContext(userContext);
    const simpleValidator = useRef(new SimpleReactValidator())

    var job_status = [
        { id: 1, name: "I am happy where I am but don't mind finding good opportunities" },
        { id: 2, name: "I am unemployed and desperate for a job" },
        { id: 3, name: "I am actively looking for new opportunities and jobs" },
        { id: 4, name: "I am only interested in very specific opportunities" },
        { id: 5, name: "I am not looking for a job" }
    ]

    useEffect(() => {
        getInterest();
        // eslint-disable-next-line
    }, []);

    const getInterest = () => {
        var url = stud_id ? `can-career-interest/?candidate=${stud_id}` : "can-career-interest/";
        axiosInstance(
            url, {
            method: "GET",
            data: {}
        }).then(res => {
            setInput(res?.data?.results?.[0]);
        }).catch(err => {
            swal("", Object.values(err.response.data), "error", { button: "Ok!", });
        })
    }

    const handleChange = (e, name, type, url) => {
        if (["dropdown"].includes(type)) {
            setInput({ ...input, [name]: e });
        } else {
            setInput({ ...input, [e.target.name]: e.target.value })
        }
        if (type === "dropdown") {
            var newVal = Array.isArray(e) && e?.filter(res => res.__isNew__ === true);
            if (newVal?.length > 0) {
                axiosInstance(
                    url, {
                    method: "POST",
                    data: { name: newVal?.[0]?.name }
                }).then(res => {
                    newVal[0].id = res.data?.id;
                    delete newVal[0]['__isNew__'];
                    setInput({ ...input, [name]: e });
                }).catch(err => {
                    swal("", Object.values(err.response.data).join(", "), "error", { button: "Ok!", });
                })
            }
        }
    }

    const handleSubmit = () => {
        if (!(simpleValidator.current.allValid())) {
            simpleValidator.current.showMessages();
            forceUpdate(1);
        } else {
            input["job_types"] = getAPIIds(input?.job_types)
            input["job_titles"] = getAPIIds(input?.job_titles)
            input["job_categories"] = getAPIIds(input?.job_categories)
            input["place_to_work"] = getAPIIds(input?.place_to_work)
            input["current_currier_level"] = input?.current_currier_level?.id
            input["current_job_search_status"] = input?.current_job_search_status?.id
            input["candidate"] = stud_id ?? user?.id;
            input["salary_type"] = "m";

            var url = input?.id ? `can-career-interest/${input?.id}/` : "can-career-interest/";
            var method = input?.id ? "PUT" : "POST";

            axiosInstance(
                url, {
                method: method,
                data: input
            }).then(res => {
                if (res?.status === 200 || res?.status === 201) {
                    getInterest();
                    swal("", "Update Succesfully", "success", { button: "Ok!", });
                }
            }).catch(err => {
                swal("", Object.values(err.response.data).join(", "), "error", { button: "Ok!", });
            })
        }
    }

    const handleReset = () => {
        axiosInstance(
            `can-career-interest/${input?.id}`, {
            method: "DELETE",
        }).then(res => {
            setInput({});
        }).catch(err => {
            swal("", Object.values(err.response.data).join(", "), "error", { button: "Ok!", });
        })
    }

    return (
        <div id="resume_headline_bx" className=" job-bx bg-white m-b30">
            <div className="d-flex">
                <h5 className="m-b15">Career Interest</h5>
            </div>

            <div className="row">
                <div className="col-12 col-md-6 mb-3">
                    <Dropdown
                        url="career-level/"
                        title='Current career level?'
                        name="current_currier_level"
                        value={input?.current_currier_level}
                        onChange={handleChange}
                        required={true}
                    />
                    <span className="text-danger font-weight-bold">
                        {simpleValidator.current.message("current career level", input?.current_currier_level, "required")}
                    </span>
                </div>
                <div className="col-12 col-md-6 mb-3">
                    <CreatableDropdown
                        url="job-types/"
                        type="multiselect"
                        title='Type(s) of job are you open to?'
                        name="job_types"
                        value={input?.job_types}
                        onChange={handleChange}
                        required={true}
                    />
                    <span className="text-danger font-weight-bold">
                        {simpleValidator.current.message("Type(s) of job are you open to", input?.job_types, "required")}
                    </span>
                </div>
                <div className="col-12 col-md-6 mb-3">
                    <CreatableDropdown
                        url="job-titles/"
                        type="multiselect"
                        title='Job titles that describes you looking for?'
                        name="job_titles"
                        value={input?.job_titles}
                        onChange={handleChange}
                        required={true}
                    />
                    <span className="text-danger font-weight-bold">
                        {simpleValidator.current.message("Job titles", input?.job_titles, "required")}
                    </span>
                </div>
                <div className="col-12 col-md-6 mb-3">
                    <CreatableDropdown
                        url="job-categories/"
                        type="multiselect"
                        title='Job categories are you interested in?'
                        name="job_categories"
                        value={input?.job_categories}
                        onChange={handleChange}
                        required={true}
                    />
                    <span className="text-danger font-weight-bold">
                        {simpleValidator.current.message("Job categories", input?.job_categories, "required")}
                    </span>
                </div>
                <div className="col-12 col-md-6 mb-3">
                    <Dropdown
                        url="country/"
                        type="multiselect"
                        title='Where would you like to work?'
                        name="place_to_work"
                        value={input?.place_to_work}
                        onChange={handleChange}
                        required={true}
                    />
                    <span className="text-danger font-weight-bold">
                        {simpleValidator.current.message("place to work", input?.place_to_work, "required")}
                    </span>
                </div>
                <div className="col-12 col-md-6">
                    <InputField
                        label="Minimum salary you would accept?"
                        name="min_salary_expect"
                        type="number"
                        value={input?.min_salary_expect || ''}
                        onChange={handleChange}
                        required={true}
                        placeholder="Enter Minimum salary (per month)"
                        onKeyPress={e => e.target.value.length >= 8 && e.preventDefault()}
                    />
                    <span className="text-danger font-weight-bold">
                        {simpleValidator.current.message("Minimum salary", input?.min_salary_expect, "required")}
                    </span>
                </div>
                <div className="col-12 mb-3">
                    <Dropdown
                        title='Your current job search status?'
                        name="current_job_search_status"
                        value={input?.current_job_search_status}
                        onChange={handleChange}
                        options={job_status}
                        required={true}
                    />
                    <span className="text-danger font-weight-bold">
                        {simpleValidator.current.message("current job search status", input?.current_job_search_status, "required")}
                    </span>
                </div>
            </div>
            <div>
                <button
                    type="button"
                    className="site-button mr-2"
                    onClick={() => handleSubmit()}
                    disabled={!input ? true : false}
                    style={{ backgroundColor: input ? "#1d46f5" : "#8b99d5", cursor: input ? "pointer" : "not-allowed" }}
                >
                    Save
                </button>
                {
                    input?.id &&
                    <button
                        type="button"
                        className="site-button btn-danger"
                        onClick={() => handleReset()}
                    >
                        Reset
                    </button>
                }
            </div>
        </div>
    );
}

export default CareerInterest;